import * as _ from 'lodash';


const sizeWidth = '90px';
const shareWidth = '90px';
const tooltipWidth = '20px';
const downloadWidth = '120px';
const nameWidth = `calc(100% - ${sizeWidth} - ${shareWidth} - ${downloadWidth} - ${tooltipWidth})`;

export const columns: any = [
  {
    title: 'Name',
    width: nameWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'filename',
    active: false,
    col: 'filename',
    truncate: true,
  },
  {
    title: 'Size',
    width: sizeWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'size',
    active: false,
    col: 'size',
    type: 'size',
  },
  {
    title: 'Share',
    width: shareWidth,
    sortable: false,
    active: false,
    col: 'link',
    type: 'btn',
    config: {
      type: 'share-link',
      link: (row: any) => {
          return _.get(row, 'link');
      },
      completed: (row: any) => {
          return _.get(row, 'completed');
      },
      nameCompleted: 'Share',
      isFailed: (row: any) => {
          return _.get(row, 'has_error') || _.get(row, 'has_xsd_errors');
      },
      linkActive: (row: any) => {
          return !!_.get(row, 'completed') && !_.get(row, 'has_error');
      },
      isInactive: (row: any) => {
          return _.get(row, 'isInactive');
      },
    }
  },
  {
    title: '',
    width: tooltipWidth,
    sortable: false,
    align: 'right',
    active: false,
    col: 'has_xsd_errors',
    type: 'tooltip',
    config: {
      innerHtml: 'File has XSD errors!',
      placement: 'left'
    }
  },
  {
    title: '',
    width: downloadWidth,
    sortable: false,
    active: false,
    align: 'right',
    col: 'download',
    icon: 'download-icon',
    type: 'btn',
    config: {
      type: 'download-item',
      link: (row: any) => {
        return _.get(row, 'link');
      },
      completed: (row: any) => {
        return _.get(row, 'completed');
      },
      nameCompleted: 'DOWNLOAD',
      isFailed: (row: any) => {
        return _.get(row, 'has_error') || _.get(row, 'has_xsd_errors');
      },
      isWarning: (row: any) => {
        return _.get(row, 'error_level') === 2;
      },
      linkActive: (row: any) => {
        return !!_.get(row, 'completed') && !_.get(row, 'has_error');
      },
      isInactive: (row: any) => {
        return _.get(row, 'isInactive');
      },
    }
  },
];
